


import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
    console.log("resp=", response)
    console.log("response?.status =", response?.status)
    console.log(" response?.data?.status=", response?.data)
    if (response?.status === "SUCCESS" && response?.data?.status === "SUCCESS")
        return isSuccessResponse(response)
    else
        throw {
            message: "An Unexpected error has occoured",
        }
}

const getAssignedDevicesToMidApi = (mid: String, tokens: any) => {
    const request: JFSRequest<{}> = {
        apiPath: getUrl(APIEndPoints.getAssingedDevicesToMid),
        method: 'POST',
        config: sitConfig(tokens),
        headers: getHeaders() as any,
        body: getAssignedDevicesToMidApiRequest(mid),
    }

    return executeRequest(request)
        .then(responseParser)
        .catch((error) => {
            throw error
        })
}

export const getAssignedDevicesToMidApiRequest = (mid: String) => ({ mid })


export { getAssignedDevicesToMidApi }
